module.exports = __webpack_public_path__ + "img/21.5bd2a87b.png";